
  const __registry__ = require('../../../../spiferack/client/index.js')
  'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var React = require('react');
var connect = require('../../../components/connect');

var _require = require('./constants'),
    PERMISSION_NO_ACCESS = _require.PERMISSION_NO_ACCESS,
    ORGS_PERMISSION = _require.ORGS_PERMISSION,
    ORGS = _require.ORGS,
    SELECTED_ORGS = _require.SELECTED_ORGS;

var OrganizationsInput = require('./organizations-input');
var PermissionsInput = require('./permissions-input');
var Section = require('./section');
var formStyles = require('../../../../shared/styles/forms.css');

function OrgsSection(props) {
  var _React$useState = React.useState(PERMISSION_NO_ACCESS),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      permission = _React$useState2[0],
      setPermission = _React$useState2[1];

  function onPermissionSelect(permission) {
    setPermission(permission);
    props.onInputChange(ORGS_PERMISSION, permission);
    // Reset orgs selection if no access is selected
    if (permission === PERMISSION_NO_ACCESS) {
      props.dispatch({
        type: 'FORM_CHANGE',
        formId: props.formId,
        name: SELECTED_ORGS,
        value: []
      });
    }
  }

  var formId = props.formId,
      formData = props.formData,
      allOrgs = props.allOrgs,
      onInputChange = props.onInputChange;


  var sectionId = formId + '_organizations_section';
  var errorMessageId = sectionId + '_error_message';
  var errorMessage = formData[formId][ORGS_PERMISSION].errorMessage;

  return React.createElement(
    Section,
    { title: 'Organizations', id: sectionId },
    React.createElement(PermissionsInput, {
      formId: formId,
      name: ORGS_PERMISSION,
      onSelect: onPermissionSelect,
      outerLabelId: sectionId,
      isInvalid: !!errorMessage,
      ariaDescribedby: errorMessageId
    }),
    permission !== PERMISSION_NO_ACCESS && React.createElement(OrganizationsInput, {
      formId: formId,
      formData: formData,
      name: ORGS,
      allOrgs: allOrgs,
      onInputChange: onInputChange
    }),
    React.createElement(
      'p',
      { id: errorMessageId, className: formStyles.errorMessage },
      errorMessage
    )
  );
}

module.exports = connect()(OrgsSection);
  let __hot__
  
  __registry__.register('tokens/gat/organizations-section', module.exports, __hot__)
  